import { FC, useEffect, useState } from "react";
import { QESAlert, QESButton } from "../shared/qes-standards";
import ProcessExceptionsModal from "./ProcessExceptionsModal";
import SpecialtyGroupExceptionsService from "@app/projects/specialtyGroupExceptionsService";

const UnprocessedExceptionsBanner: FC = () => {
  const specialtyGroupExceptionsService = new SpecialtyGroupExceptionsService();
  const [isProcessConfirmationModalOpen, setIsProcessConfirmationModalOpen] = useState<boolean>(false);
  const [isBannerVisible, setIsBannerVisible] = useState<boolean>(false);

  useEffect(() => {
    specialtyGroupExceptionsService.hasUnprocessedSpecialtyGroupExceptions()
    .then(hasUnprocessedExceptions =>
    {
      setIsBannerVisible(hasUnprocessedExceptions);
    });
  }, []);

  return (
    <>
      {isBannerVisible && (
        <QESAlert type="warning" persist={true} classNames="mt-3">
          Some specialty group exceptions are not yet processed. Exceptions in &quot;Read Only&quot; projects will not be processed. &nbsp;
          <QESButton
            qesType="secondary"
            qesTestId={`exception__processconfirmation`}
            onClick={() => setIsProcessConfirmationModalOpen(true)}
          >
            Process Now
          </QESButton>
        </QESAlert>
      )}
      <ProcessExceptionsModal
        isModalOpen={isProcessConfirmationModalOpen}
        setIsModalOpen={setIsProcessConfirmationModalOpen}
        onSuccess={()=> setIsBannerVisible(false)}
      />
    </>
  );
};

export default UnprocessedExceptionsBanner;